module.exports = new __parcel__URL__("blueprint.422f9298.svg").toString();